import { render, staticRenderFns } from "./CurrentReservation.vue?vue&type=template&id=0c8e7712"
import script from "./CurrentReservation.vue?vue&type=script&lang=js"
export * from "./CurrentReservation.vue?vue&type=script&lang=js"
import style0 from "./CurrentReservation.vue?vue&type=style&index=0&id=0c8e7712&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports